export default __webpack_public_path__ + "static/media/b5.652b8457.jpg";